import type { MaterialValue } from "@rogue/rackbuilder"

export const AdjustOnlyVisual = 2

export const RACK_COLORS: { [key: string]: string } = {
  'Satin Black'                             : '#1C1C1C',
  'Rogue Red'                               : '#d52716',
  Red                                       : '#ff321f',
  'Bright Blue'                             : '#31679b',
  'Bright Green'                            : '#62c727',
  'Dark Blue'                               : '#344866',
  Blue                                      : '#344866',
  'Gun Metal'                               : '#616161',
  'Satin Clear'                             : 'satinClear',
  'Stainless Steel'                         : 'stainless',
  'Burnt Orange'                            : '#ff5a0f',
  'Dark Red'                                : '#9d3434',
  'Desert Tan'                              : '#BDAA94',
  'Textured Black'                          : 'powdercoat',
  White                                     : '#FFFFFF',
  'Textured Charcoal Gray / Textured Black' : 'powdercoat',
  'Matte Black'                             : 'matte',
}

const anodized = (color: string): MaterialValue => ({ material: 'knurl', color, config: { mapRepeat: 1.6, metalness: 0.8, roughness: 0.35 } })

export const ANODIZED_COLORS: { [key: string]: MaterialValue } = {
  'Raw Aluminum' : { material: 'knurl', color: '#C0C5C9', config: { mapRepeat: 1.6, metalness: 0.4, roughness: 0.9 } },
  Black          : anodized('#2B2B2B'),
  Blue           : anodized('#2992EE'),
  Red            : anodized('#B40416'),
  'Gun Metal'    : anodized('#6E6E6E'),
}

export const COLOR_TO_MATERIAL_KEYS = ['powdercoat', 'satinClear', 'stainless', 'matte']

// RACK_COLORS entries are either a hex color or a material key (satinClear/stainless/powdercoat/matte) — this picks the right shape.
export function resolveColorMaterial(colorName: string | undefined, fallbackMaterial: MaterialValue['material'] = 'mg'): MaterialValue {
  // An unmapped finish name would reach THREE.Color as-is and throw, so fall back the way handleSplitColorUprights does.
  const resolved = RACK_COLORS[colorName ?? ''] ?? RACK_COLORS['Satin Black']

  if (COLOR_TO_MATERIAL_KEYS.includes(resolved)) {
    return { material: resolved as MaterialValue['material'] }
  }

  return { material: fallbackMaterial, color: resolved }
}
